// @ts-nocheck
import { CONTACT_ADMIN_ERROR, CONTACT_ADMIN_LOADING, CONTACT_ADMIN_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const contact_admin = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: CONTACT_ADMIN_LOADING,
                data: true
            })
            Authservices.contact_admin(data).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: CONTACT_ADMIN_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: CONTACT_ADMIN_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}